import { AnyAction } from 'redux';

import { SIDEBAR_UPDATE } from './bonus-settlements-detail-sidebar-actions';

export interface BonusSettlementDetailSidebarReducerState {
    detailSidebarCollapsed: boolean;
}

const initialSettingsReducerState: { detailSidebarCollapsed: boolean } = {
    detailSidebarCollapsed: false,
};

export const bonusSettlementDetailSidebarReducer = (
    state: { detailSidebarCollapsed: boolean } = initialSettingsReducerState,
    action: AnyAction
): { detailSidebarCollapsed: boolean } => {
    const { type, settings } = action;
    switch (type) {
        case SIDEBAR_UPDATE: {
            return {
                ...state,
                ...settings,
            };
        }
        default: {
            return state;
        }
    }
};
